import React, { useState } from 'react';
import { ChoiceGroup, ChoiceGroupItem } from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { ITEM_ALL_ID } from '../ServicesAndSkills/consts';
import { choiceGroupStyles } from './styles.ve.css';
import { ServiceOrSkillItem } from './types';
import { CollapsibleTags } from './CollapsibleTags/CollapsibleTags';

export interface ServicesAndSkillsTagsProps {
    items: ServiceOrSkillItem[];
    initialVisibleItems?: number;
    onChange: (id?: string | null) => void;
}

export const ServicesAndSkillsTags = ({ items, onChange, initialVisibleItems }: ServicesAndSkillsTagsProps) => {
    const [groupValue, setGroupValue] = useState<string | null>(items[0].id);

    const handleChange = (id: string | null) => {
        setGroupValue(id);
        onChange(id);
    };

    return (
        <>
            <CollapsibleTags items={items} onChange={onChange} initialVisibleItems={initialVisibleItems} />
            <Container
                display={{
                    default: 'flex',
                    md: 'none',
                }}
                overflowX="auto"
                maxWidth="100%"
                className={choiceGroupStyles}
            >
                <ChoiceGroup
                    maxWidth="100%"
                    overflow="auto"
                    multiple={false}
                    value={groupValue}
                    onChange={handleChange}
                >
                    {items.map((item) => (
                        <ChoiceGroupItem key={item.id} value={item.id}>
                            {`${item.name} ${item.count && item.id !== ITEM_ALL_ID ? `(${item.count})` : ''}`}
                        </ChoiceGroupItem>
                    ))}
                </ChoiceGroup>
            </Container>
        </>
    );
};
